import { createStyles, makeStyles } from '@material-ui/styles';
import Sincronizacao from '../icons/icon-img/sincronizacao.png'

export const DadosSincronizacaoIcon = () => {
  const useStyles = makeStyles(() => 
    createStyles({
      img: {
        width: '25px',
        height: '25px'
      },
    })
  )
  const classes = useStyles();
  return (
    <>
      <img
      className={classes.img}
      src={Sincronizacao} 
      alt="" 
      />
    </>
  );
};
